import { CrudModel, EntityDescription } from "./_crud";
import SolutionModel from "./solution.model";
import QualificationModel from "./qualification.model";

export class SolutionQualificationModel extends CrudModel {
	constructor() {
		super(
			"admin/solutionQualifications",
			[],
			[
				{ fieldKey: "solution", model: SolutionModel },
				{ fieldKey: "qualification", model: QualificationModel },
			],
		);
	}
}

export default new SolutionQualificationModel();
